import { render } from "./MigrateV5Dialog.vue?vue&type=template&id=f978af3a&scoped=true"
import script from "./MigrateV5Dialog.vue?vue&type=script&lang=ts"
export * from "./MigrateV5Dialog.vue?vue&type=script&lang=ts"

import "./MigrateV5Dialog.vue?vue&type=style&index=0&id=f978af3a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f978af3a"

export default script